import apiClient from "../../service/apiClient";
import qs from "qs";
import { GetVendorsResponse } from "../models/response/get-vendors-response";
import { GetVendorRequest } from "../models/request/get-vendor-request";
import { GetVendorResponse } from "../models/response/get-vendor-response";
import { EditVendorRequest } from "../models/request/edit-vendor-request";
import { EditVendorResponse } from "../models/response/edit-vendor-response";
import { DeleteVendorRequest } from "../models/request/delete-vendor-request";
import { DeleteVendorResponse } from "../models/response/delete-vendor-response";
import { CreateVendorRequest } from "../models/request/create-vendor-request";
import { CreateVendorResponse } from "../models/response/create-vendor-response";
import { GetFiltersRequest } from "pages/admin-app/shared/models/request/get-filters-request";
import { GetFiltersResponse } from "pages/admin-app/shared/models/response/get-filters-response";
import { GetSortAndFilterRequest } from "pages/admin-app/shared/models/request/get-sort-filters-request";
import { GetVendorsRequest } from "../models/request/get-vendors-request";

export async function getVendors(
  request: GetSortAndFilterRequest
): Promise<GetVendorsResponse> {
  const response = await apiClient.get<GetVendorsResponse>("/vendor/search", {
    params: {
      page: request.page,
      perPage: request.perPage,
      sortBy: request.sortBy,
      orderBy: request.orderBy,
      filters: request.filters,
      searchQuery: request.searchQuery,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { encode: true, arrayFormat: "brackets" }),
  });
  return response.data;
}

export async function getPaginatedByNameVendors(
  request: GetVendorsRequest
): Promise<GetVendorsResponse> {
  const response = await apiClient.get<GetVendorsResponse>(
    "/vendor/search-by-name",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        searchQuery: request.searchQuery,
      },
    }
  );
  return response.data;
}

export async function getVendor(
  request: GetVendorRequest
): Promise<GetVendorResponse> {
  const response = await apiClient.get<GetVendorResponse>(
    `/vendor/${request.vendorId}`
  );
  return response.data;
}

export async function updateVendor({
  vendorId,
  ...vendorData
}: EditVendorRequest): Promise<EditVendorResponse> {
  const response = await apiClient.patch<EditVendorResponse>(
    `/vendor/${vendorId}`,
    vendorData
  );
  return response.data;
}

export async function deleteVendor(
  request: DeleteVendorRequest
): Promise<DeleteVendorResponse> {
  const response = await apiClient.delete<DeleteVendorResponse>(
    `/vendor/${request.vendorId}`
  );

  return response.data;
}

export async function createVendor(
  vendorData: CreateVendorRequest
): Promise<CreateVendorResponse> {
  const response = await apiClient.post<CreateVendorResponse>(
    "/vendor",
    vendorData
  );
  return response.data;
}

export async function getVendorFilters(
  request: GetFiltersRequest
): Promise<GetFiltersResponse> {
  const response = await apiClient.get<GetFiltersResponse>("/vendor/filters", {
    params: {
      field: request.field,
      subCategoryQuery: request.subCategoryQuery,
      limit: request.limit,
      afterKey: request.afterKey,
    },
  });
  return response.data;
}
